import {Injectable, Inject} from '@angular/core';
import {
  RestService,
  RestYiiFilterService,
  RestYiiSort,
  RestYiiPagination,
  RestSimpleResponseParser,
  RestQueryParams
} from 'gelios-ng-admin-components';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

// import {HttpClient} from '@angular/common/http';

@Injectable()
export class UnitLogService <T> extends RestService <T> {

  public get url(): string {
    return environment.apiBasepoint + 'unit-log';
  }

  constructor(
    protected http: HttpClient,
    protected _filter: RestYiiFilterService,
    protected _sort: RestYiiSort,
    protected _pagination: RestYiiPagination,
    protected _parser: RestSimpleResponseParser,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {
    super(http, _filter, _sort, _pagination, _parser, environmentVersion, environmentApiBasepoint);
    this._filter.searchModelName = 'UnitLogSearch';
  }

}
